<template>
  <div style="padding: 20px 0px 0px 20px;">

    <el-form style="display: flex;flex-wrap: wrap;">
      <el-form-item label="添加人:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择添加人" v-model="input1" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="添加时间:" style="display: flex;width: 60%;">
        <el-date-picker v-model="input2" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" clearable>
        </el-date-picker>
      </el-form-item>


      <el-form-item label="项目名称:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择项目名称" v-model="input3" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList3" :key="item.id" :value="item.integralName" :label="item.integralName"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="项目类型:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择项目类型" v-model="input4" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList5" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>


      <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus"
          @click="searchAddBtns">添加项目</el-button>
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"
          @click="searchBtns">搜索</el-button>
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close"
          @click="clearBtns">清空</el-button>
      </div>

    </el-form>


    <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }" :data="dataList" border height="700">
      <el-table-column prop="createName" label="添加人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="integralName" label="项目名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="integralType" label="项目类型" show-overflow-tooltip>
         <template v-slot="scope">
          <div v-if="scope.row.integralType === 1">加分</div>
          <div v-if="scope.row.integralType === 2">减分</div>
        </template>
      </el-table-column>
      <el-table-column prop="integralDescribe" label="项目描述" show-overflow-tooltip></el-table-column>
      <el-table-column prop="integralNum" label="积分数量" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="添加时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="integralStatus" label="项目状态" show-overflow-tooltip>
        <template v-slot="scope">
          <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);"
            v-if="scope.row.integralStatus === 0">无效</div>
          <div style="display: flex;justify-content: space-around;color:rgb(23 226 31);"
            v-if="scope.row.integralStatus === 1">有效</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template v-slot="scope">
          <div style="display: flex;justify-content: space-around;">
            <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
      :page-size="pageSize" layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>

    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" :title="Titlecenter"
      :visible="addShow" :before-close="closeEditDialog" width="70%">

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">项目名称:</div>
        <el-input v-model="inputValue1" placeholder="请输入项目名称" clearable></el-input>
      </div>

      <div style="display: flex; margin-bottom: 40px;">
        <div style="width: 80px;padding-top: 10px;">项目类型:</div>
        <el-select placeholder="请选择项目类型" v-model="input7" style="width: 100%" clearable filterable>
            <el-option v-for="item in optionList5" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">项目描述:</div>
        <el-input v-model="inputValue4" placeholder="请输入项目名称" :autosize="{ minRows: 8, maxRows: 8 }" type="textarea"  maxlength="500" show-word-limit></el-input>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">项目分数:</div>
        <el-input-number style="width: 100%;" v-model="inputValue2" :max="999999" label="请输入项目分数"></el-input-number>
      </div>

      <div style="display: flex; margin-bottom: 40px;">
        <div style="width: 80px;padding-top: 10px;">项目状态:</div>
        <el-select placeholder="请选择审批状态" v-model="inputValue3" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList4" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </div>


      <div style="display: flex; margin-bottom: 20px; justify-content: center;">
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('取消')">取消</el-button>
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('确定')">确定</el-button>
      </div>




    </el-dialog>

  </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { getTeachers } from "@/api/fiveClassApi"


export default {
  components: {

  },
  data() {
    return {
      inputValue4: '',

      input7: '',

      inputValue1: '',
      inputValue2: 1 ,
      inputValue3: '',

      Titlecenter: '添加积分项目',
      optionList4: [{ id: 0, name: '无效' }, { id: 1, name: '有效' }],

      optionList5: [{ id: 1, name: '加分' }, { id: 2, name: '减分' }],

      optionList1: [],
      optionList2: [],
      optionList3: [],

      input1: '',
      input2: [],
      input3: '',

      dataList: [],

      pageNum: 1,
      pageSize: 10,
      total: 0,


      CourseCancellationComponentsType: '',
      CourseCancellationComponentsID: '',
      CourseCancellationComponentsShow: false,

      CourseCancellationomponentsTypeDistinguish: '课消审批',




      addShow: false,

      inputID:'',

      input4: '',

    }
  },

  mounted() {
    getTeachers().then(res => { this.optionList1 = res.data })
    axios.get(`${apiBaseUrl}/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => { this.optionList2 = res.data.data })


    this.handleintegralProject()
    this.getApiList()

  },


  methods: {


    handleintegralProject(){
      axios.post(`${apiBaseUrl}/integralProject/findList`, { integralName:'' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.optionList3 = data
        } else {
          this.optionList3 = []
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleClickViewBtn(type){

      if(type === '取消'){
          this.inputValue1 = ''
          this.inputValue2 = 1
          this.inputValue3 = ''
          this.Titlecenter = ''
          this.inputValue4 = ''
          this.inputID = ''
          this.input7 = ''
          this.addShow = false
      }

      if(type === '确定'){

        if(this.inputValue1 === ''){
          this.$message.warning('请输入项目名称')
          return
        }

        if(this.inputValue3 === ''){
          this.$message.warning('请选择项目状态')
          return
        }


        if(this.inputID){

          let data = {
            integralName: this.inputValue1,
            integralNum: this.inputValue2,
            integralStatus: this.inputValue3,
            integralDescribe: this.inputValue4,
            id: this.inputID,
            integralType: this.input7,
          }

          axios.post(`${apiBaseUrl}/integralProject/modify`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
            if (res.data.code === 200) {
              this.$message({ message:res.data.message, type: "success" })

              this.inputID = ''
              this.inputValue1 = ''
              this.inputValue2 = 1
              this.inputValue3 = ''
              this.inputValue4 = ''
              this.Titlecenter = ''
              this.input7 = ''

              this.handleintegralProject()
              this.addShow = false

              setTimeout(() => {  this.getApiList()  }, 1000)
            } else {
              this.$message.error(res.data.message)
            }
          }).catch((err) => {
            this.$message.error(err)
          })

        }else{

          let data = {
            integralName: this.inputValue1,
            integralNum: this.inputValue2,
            integralStatus: this.inputValue3,
            integralDescribe: this.inputValue4,
            integralType: this.input7,
          }

          axios.post(`${apiBaseUrl}/integralProject/add`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
            if (res.data.code === 200) {

              this.inputValue1 = ''
              this.inputValue2 = 1
              this.inputValue3 = ''
              this.inputValue4 = ''
              this.Titlecenter = ''
              this.handleintegralProject()
              this.addShow = false

              this.$message({ message:res.data.message, type: "success" })
              setTimeout(() => {  this.getApiList()  }, 1000)
            } else {
              this.$message.error(res.data.message)
            }
          }).catch((err) => {
            this.$message.error(err)
          })

        }
      }

    },

    searchAddBtns() {
      this.Titlecenter = '添加积分项目'
      this.addShow = true
    },

    closeEditDialog() {
      this.Titlecenter = ''
      this.inputValue1 = ''
      this.inputValue2 = 0
      this.inputValue3 = ''
      this.inputID = ''
      this.input7 = ''

      this.addShow = false
    },

    CourseCancellationhandleEmit(e) {
      this.CourseCancellationComponentsShow = e
    },

    searchBtns() {
      this.pageNum = 1
      this.pageSize = 10
      this.getApiList()
    },

    clearBtns() {
      this.pageNum = 1
      this.pageSize = 10
      this.input1 = ''
      this.input2 = []
      this.input3 = ''
      this.input4 = ''
      this.getApiList()
    },

    getApiList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        integralName: this.input3,
        createId: this.input1,
        createDateStartTime: (this.input2 && this.input2.length > 0) ? this.input2[0] + ' 00:00:00' : null,
        createDateeEndTime:  (this.input2 && this.input2.length > 0) ? this.input2[1] + ' 00:00:00' : null,
        integralType: this.input4,
      }
      axios.post(`${apiBaseUrl}/integralProject/findPage`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList = data.records
          this.pageNum = data.current ? data.current : 0
          this.pageSize = data.size ? data.size : 10
          this.total = data.total ? data.total : 0

          if(data.records && data.records.length < 0){
            this.dataList = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleSizeChange(e) {
      this.pageSize = e
      this.getApiList()
    },

    handleCurrentChange(e) {
      this.pageNum = e
      this.getApiList()
    },

    handleClickView(type, itme) {

      if (type === '编辑') {
        console.log(itme)
        this.Titlecenter = '编辑积分项目'

        this.inputValue1 = itme.integralName
        this.inputValue2 = itme.integralNum
        this.inputValue3 = itme.integralStatus
        this.inputValue4 = itme.integralDescribe
        this.input7 = itme.integralType

        this.inputID = itme.id

        this.addShow = true

      } else {
        this.CourseCancellationComponentsType = type
        this.CourseCancellationComponentsID = itme.id
        this.CourseCancellationComponentsShow = true

        this.$nextTick(() => {
          this.$refs.CourseCancellationomponents.handleInit(itme.id)
        })
      }


    },


  }

}
</script>


<style scoped lang="less">
.no-click {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/PointsManagement/ProjectSettings.vue